import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { CheckboxChangeEvent } from 'primeng/checkbox';

@Component({
    selector: 'medsurf-design-input-checkbox',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './checkbox.input.design.html',
    styleUrls: ['./checkbox.input.design.scss'],
    standalone: false
})
export class CheckboxInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() label?: string;
  @Input() disabled = false;
  @Input() labelTop = false;
  @Input({ required: true }) model!: boolean;
  @Output() valueChange = new EventEmitter<CheckboxChangeEvent>();
}
